import React from 'react';
import { connect } from 'react-redux';
import selectDialogConfig from '../../../store/dialog/dialog.selectors';
import DocUploadSuccessDialog from './DocUploadSuccessDialog';
import DocUploadErrorDialog from './DocUploadErrorDialog';
import LogoutDialog from './LogoutDialog';
import AutoLogoutDialog from './AutoLogoutDialog';
import DocUploadFilesTooBigDialog from './DocUploadFilesTooBigDialog';
import DocUploadFileTypeNotAllowedDialog from './DocUploadFileTypeNotAllowedDialog';
import DocListErrorDialog from './DocListErrorDialog';
import OpenBankingErrorDialog from './OpenBankingErrorDialog';
import OpenBankingPdfGenerated from './OpenBankingPdfGenerated';

const DIALOG_COMPONENTS = {
  DOC_UPLOAD_SUCCESS: DocUploadSuccessDialog,
  DOC_UPLOAD_ERROR: DocUploadErrorDialog,
  DOC_UPLOAD_FILES_TOO_BIG: DocUploadFilesTooBigDialog,
  DOC_UPLOAD_FILE_TYPE_NOT_ALLOWED: DocUploadFileTypeNotAllowedDialog,
  LOGOUT_DIALOG: LogoutDialog,
  AUTO_LOGOUT_DIALOG: AutoLogoutDialog,
  DOC_LIST_ERROR: DocListErrorDialog,
  OPEN_BANKING_PDF_GENERATED: OpenBankingPdfGenerated,
  OPEN_BANKING_ERROR: OpenBankingErrorDialog,
};

export const DIALOGS = Object.keys(DIALOG_COMPONENTS).reduce((prev, curr) => {
  prev[curr] = curr;
  return prev;
}, {});

interface Props {
  dialogConfig?: {
    dialogType: string;
    dialogProps: Record<string, unknown>;
  } | null;
}

const RootDialog = ({ dialogConfig }: Props) => {
  if (!dialogConfig) {
    return null;
  }
  const { dialogType, dialogProps } = dialogConfig;

  const SpecificDialog = DIALOG_COMPONENTS[dialogType];
  return <SpecificDialog {...dialogProps} />;
};

const mapStateToProps = (state) => ({
  dialogConfig: selectDialogConfig(state),
});

export default connect(mapStateToProps, null)(RootDialog);
